import { Box, styled } from '@mui/joy';

export const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

export const TitleWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '32px',
});
